import { JobsService } from 'app/API';
import type { TUploaderAdapter } from '@components/Files/UploadProvider/types/TUploadParams';

type TUploadLinkRequest = Parameters<typeof JobsService.getJobAttachmentUploadLink>[0];
type TUploadLinkResponse = Awaited<ReturnType<typeof JobsService.getJobAttachmentUploadLink>>['body'];

export const AttachmentUploader = (
  requestUploadLink: (request: TUploadLinkRequest) => Promise<TUploadLinkResponse>,
  getJobId: () => string,
  organizationId: string,
): TUploaderAdapter => ({
  requestParams: async ({ file, meta }) => {
    void file;
    const jobId = getJobId();
    const { url } = await requestUploadLink({
      jobId,
      file: meta.name,
      oid: organizationId,
    });
    return { url, method: 'PUT' };
  },
  performUpload: async ({ file, params, onProgress, signal }) => {
    if (!(file instanceof File)) {
      throw new Error('Only File supported');
    }
    return new Promise<{ serverId?: string }>((resolve, reject) => {
      const xhr = new XMLHttpRequest();
      xhr.open('PUT', params.url);
      xhr.upload.onprogress = (e) => {
        if (e.lengthComputable && onProgress) {
          onProgress((e.loaded / e.total) * 100);
        }
      };
      xhr.onload = () => {
        if (xhr.status >= 200 && xhr.status < 300) {
          resolve({});
          return;
        }
        reject(new Error(`Attachment upload failed ${xhr.status}`));
      };
      xhr.onerror = () => reject(new Error('Network error during attachment upload'));
      if (signal) {
        signal.addEventListener('abort', () => xhr.abort());
      }
      xhr.send(file);
    });
  },
});
